module.exports = __webpack_public_path__ + "img/021.cc9d287e.jpeg";